export default [
    {
        path: '/legal/informacion-empresa',
        name: 'informacion-empresa',
        component: () =>
            import ('@/views/pages/legal/InformeLegal.vue'),
        meta: {
			title: 'i18n:legal.informes.info_empresa.titulo',
            resource: 'Legal',
            action: 'ver-legal-informe-informacion-empresa',
            pageTitle: 'legal.informes.info_empresa.titulo',
            breadcrumb: [{
                text: "Legal",
                active: true
            },
            {
                text: "Informes",
                active: true
            },
        ]
        },
    },
    {
        path: '/legal/empresa/:cod_empresa',
        name: 'empresaLegal',
        component: () =>
            import ('@/views/pages/legal/MenuEmpresa.vue'),
        meta: {
			title: 'i18n:',
            resource: 'Legal',
            action: 'ver-legal-informe-informacion-empresa',
            pageTitle: 'Empresa',
            breadcrumb: [{
                text: "Legal"
            },
            {
                text: "Informes"
            },
            {
                text: "Empresa",
                active: true
            }
        ]
        },
    },
    {
        path: '/legal/mantenimiento-empresa',
        name: 'mantenimiento-empresa',
        component: () =>
            import ('@/views/pages/legal/mantenimiento/MantenimientoEmpresa.vue'),
        meta: {
			title: 'i18n:legal.mantenimiento.empresa.titulo',
            resource: 'Legal',
            action: 'ver-legal-mantenimiento-empresa',
            pageTitle: 'legal.mantenimiento.empresa.titulo',
            breadcrumb: [
                {
                    text: "Legal",
                    active: true
                },
                {
                    text: "Mantenimiento",
                    active: true
                },
            ]
        },
    },
    {
        path: '/legal/mantenimiento-persona',
        name: 'mantenimiento-persona',
        component: () =>
            import ('@/views/pages/legal/mantenimiento/MantenimientoPersona.vue'),
        meta: {
			title: 'i18n:legal.mantenimiento.persona.titulo',
            resource: 'Legal',
            action: 'ver-legal-mantenimiento-empresa',
            pageTitle: 'legal.mantenimiento.persona.titulo',
            breadcrumb: [
                {
                    text: "Legal",
                    active: true
                },
                {
                    text: "Mantenimiento",
                    active: true
                },
            ]
        },
    },
    {
        path: '/legal/mantenimiento-tipo-documento',
        name: 'mantenimiento-tipo-documento',
        component: () =>
            import ('@/views/pages/legal/MantenimientoTipoDocumento.vue'),
        meta: {
			title: 'i18n:legal.mantenimiento.tipo_documento.titulo',
            resource: 'Legal',
            action: 'ver-legal-mantenimiento-localidad',
            pageTitle: 'legal.mantenimiento.tipo_documento.titulo',
            breadcrumb: [{
                text: "Legal",
                active: true
            },
            {
                text: "Mantenimiento",
                active: true
            },
        ]
        },
    },
    {
        path: '/legal/subir-documentos',
        name: 'subir-documentos',
        component: () =>
            import ('@/views/pages/legal/SubirDocumentos.vue'),
        meta: {
			title: 'i18n:legal.mantenimiento.documento_legal.titulo',
            resource: 'Legal',
            action: 'ver-legal-subir-documentos',
            pageTitle: 'legal.mantenimiento.documento_legal.titulo',
            breadcrumb: [
                {
                    text: 'Legal',
                    active: true,
                },
                {
                    text: 'Mantenimiento',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/legal/formato-contratos',
        name: 'formato-contratos',
        component: () =>
            import ('@/views/pages/legal/FormatoContratos.vue'),
        meta: {
			title: 'i18n:legal.transacciones.formato_contrato.titulo',
            resource: 'Legal',
            action: 'ver-legal-formato-contratos',
            pageTitle: 'legal.transacciones.formato_contrato.titulo',
            breadcrumb: [
                {
                    text: 'Legal',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/legal/estados-financieros',
        name: 'estados-financieros',
        component: () =>
            import ('@/views/pages/legal/EstadosFinancieros.vue'),
        meta: {
			title: 'i18n:legal.transacciones.estado_financiero.titulo',
            resource: 'Legal',
            action: 'ver-legal-estados-financieros',
            pageTitle: 'legal.transacciones.estado_financiero.titulo',
            breadcrumb: [
                {
                    text: 'Legal',
                    active: true,
                },
                {
                    text: 'Transacciones',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/legal/permisos-legal',
        name: 'permisos-legal',
        component: () =>
            import ('@/views/pages/legal/configuracion/PermisosUsuarios.vue'),
        meta: {
			title: 'i18n:legal.configuracion.permisos_usuarios.titulo',
            resource: 'Legal',
            action: 'ver-legal-configuracion-permisos-legal',
            pageTitle: 'legal.configuracion.permisos_usuarios.titulo',
            breadcrumb: [
                {
                    text: 'Legal',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                }
            ],
        },
    },
    {
        path: '/legal/permisos-organigrama',
        name: 'permisos-organigrama-empresarial',
        component: () =>
            import ('@/views/pages/legal/configuracion/PermisosOrganigrama.vue'),
        meta: {
			title: 'i18n:legal.configuracion.permisos_organigrama.titulo',
            resource: 'Legal',
            action: 'ver-legal-configuracion-permisos-organigrama',
            pageTitle: 'legal.configuracion.permisos_organigrama.titulo',
            breadcrumb: [
                {
                    text: 'Legal',
                    active: true,
                },
                {
                    text: 'Configuracion',
                    active: true,
                }
            ],
        },
    },
    {
        path: '/legal/organigrama-empresarial',
        name: 'organigrama-empresarial',
        component: () => import ('@/views/pages/legal/OrganigramaEmpresa.vue'),
        meta: {
			title: 'i18n:legal.informes.organigrama.titulo',
            resource: 'Legal',
            action: 'ver-legal-informe-organigrama-empresarial',
            pageTitle: 'legal.informes.organigrama.titulo',
            breadcrumb: [
                {
                    text: 'Legal',
                    active: true,
                },
                {
                    text: 'Informes',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/legal/mantenimiento-organigrama',
        name: 'mantenimiento-organigrama',
        component: () => import ('@/views/pages/legal/mantenimiento/MantenimientoOrganigrama.vue'),
        meta: {
			title: 'i18n:',
            resource: 'Legal',
            action: 'ver-legal-mantenimiento-empresa',
            pageTitle: 'Mantenimiento Organigrama',
            breadcrumb: [
                {
                    text: 'Legal',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Organigrama',
                    active: true,
                },
            ],
        },
    },
    ]
